import { getInstance } from '../helpers';
var usePerformanceData = function () {
    var instance = getInstance();
    return instance === null || instance === void 0 ? void 0 : instance.getPerformanceData();
};
export default usePerformanceData;
//# sourceMappingURL=usePerformanceData.js.map